/**
 * @generated SignedSource<<7d266f993b1b3c88f5210cb0de9ac3ed>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSimilarSoldItemsTracking_viewer$data = {
  readonly similarSoldItemsConnection?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly browseUrl: string | null;
          readonly categoryCode: string | null;
          readonly ecommerceTrackingParams: any | null;
        } | null;
        readonly itemId: string | null;
        readonly singleItemSoldPrice: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useSimilarSoldItemsTracking_viewer";
};
export type useSimilarSoldItemsTracking_viewer$key = {
  readonly " $data"?: useSimilarSoldItemsTracking_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSimilarSoldItemsTracking_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSimilarSoldItemsTracking_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 4
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "requestSourceRole",
              "value": "BUYER"
            }
          ],
          "concreteType": "SimilarSoldItemsConnectionConnection",
          "kind": "LinkedField",
          "name": "similarSoldItemsConnection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SimilarSoldItemsConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SimilarSoldItemsNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "itemId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "singleItemSoldPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Item",
                      "kind": "LinkedField",
                      "name": "item",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "browseUrl",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "categoryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "ecommerceTrackingParams",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0937dc681efcd58b6b6f4a971551787f";

export default node;
